import { createSlice } from '@reduxjs/toolkit'
import { SessionStorageKeys } from '../../components/constants'
import { extendedGetFromSessionStorage } from '../../utils';

const storedActiveChoice = JSON.parse(extendedGetFromSessionStorage(SessionStorageKeys.active_tab));
const initialActiveChoice = storedActiveChoice;

const initialState = {
  activeChoice: initialActiveChoice || "Searches",  
  vacancy: []
}

const slice = createSlice({
  name: 'activeChoice',
  initialState,
  reducers: {
    changeActiveChoice: (state, action) => {
      return {...state, activeChoice: action.payload}
    },
    setActiveVacancy: (state, { payload }) => {
      return { ...state, vacancy: payload}
    },
    resetActiveChoice: () => ({
      ...initialState,
      activeChoice: "Searches" 
    })
  },
})

const { reducer, actions } = slice

export const { changeActiveChoice, setActiveVacancy, resetActiveChoice } = actions

export default reducer
